// extracted by mini-css-extract-plugin
export default {"faq":"FaqPage_faq__WbL9g"};